import { Outlet, useLocation } from 'react-router'
import { styled } from 'styled-components'
import { match } from 'ts-pattern'
import { useMemo } from 'use-memo-one'

import {
  NewWalletRoute,
  OrdersRoute,
  PremiumCurrencyRoute,
  RootRoute,
  WalletSwapRoute,
  WatchlistRoute,
} from '@root/features/routing'
import {
  TradeRoute,
  WalletManagerRoute,
  WalletManagerWalletRoute,
} from '@root/features/routing/model'
import { Header } from '@root/widgets/header'

import { BottomNavigationExplore } from './bottom-navigation/bottom-navigation-explore'
import { BottomNavigationTrade } from './bottom-navigation/bottom-navigation-trade'

type MobileLayoutProps = {}

export const MobileLayout: React.FC<MobileLayoutProps> = () => {
  const location = useLocation()

  const shouldShowHeader = useMemo(() => {
    return match(location)
      .when(
        (location) => NewWalletRoute.match(location.pathname),
        () => false,
      )
      .when(
        (location) => WalletSwapRoute.match(location.pathname),
        () => false,
      )
      .when(
        (location) => PremiumCurrencyRoute.match(location.pathname),
        () => false,
      )
      .otherwise(() => true)
  }, [location])

  const shouldShowMainNavigation = useMemo(() => {
    return match(location)
      .when(
        (location) => RootRoute.match(location.pathname),
        () => true,
      )
      .when(
        (location) => NewWalletRoute.match(location.pathname),
        () => false,
      )
      .when(
        (location) => WalletManagerRoute.match(location.pathname),
        () => true,
      )
      .when(
        (location) => WalletManagerWalletRoute.match(location.pathname),
        () => true,
      )
      .when(
        (location) => WatchlistRoute.match(location.pathname),
        () => true,
      )
      .when(
        (location) => OrdersRoute.match(location.pathname),
        () => true,
      )
      .otherwise(() => false)
  }, [location])

  const shouldShowTradeNavigation = useMemo(() => {
    return TradeRoute.match(location.pathname)
  }, [location])

  const renderBottomNavigation = () => {
    if (shouldShowMainNavigation) {
      return <BottomNavigationExplore />
    }
    if (shouldShowTradeNavigation) {
      return <BottomNavigationTrade />
    }
  }

  return (
    <Root>
      {shouldShowHeader ? <Header /> : <div />}
      <Outlet />
      <>{renderBottomNavigation()}</>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;

  background: var(--mobile-background);
  position: relative;
  height: var(--viewport-height);
  padding-top: var(--safe-top);
`
